// Only the lodash functions the app uses: importing "lodash" whole adds ~70 KB to the first download.
import cloneDeep from "lodash/cloneDeep";
import filter from "lodash/filter";
import find from "lodash/find";
import findIndex from "lodash/findIndex";
import forEach from "lodash/forEach";
import isEmpty from "lodash/isEmpty";
import orderBy from "lodash/orderBy";
import values from "lodash/values";

export default { cloneDeep, filter, find, findIndex, forEach, isEmpty, orderBy, values };
